import React, { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Wifi, WifiOff, AlertCircle, CheckCircle, RefreshCw } from 'lucide-react'
import { useNetworkStatus } from '../../hooks/useCache'

const NetworkStatus: React.FC = () => {
  const { isOnline, connectionType } = useNetworkStatus()
  const [showStatus, setShowStatus] = useState(false)
  const [lastOfflineTime, setLastOfflineTime] = useState<Date | null>(null)

  useEffect(() => {
    if (!isOnline) {
      setLastOfflineTime(new Date())
      setShowStatus(true)
    } else {
      setShowStatus(true)
      // 3秒后隐藏在线状态
      const timer = setTimeout(() => {
        setShowStatus(false)
      }, 3000)
      return () => clearTimeout(timer)
    }
  }, [isOnline])

  const handleRetry = () => {
    window.location.reload()
  }

  const getConnectionInfo = () => {
    if (!isOnline) {
      return {
        icon: WifiOff,
        color: 'text-red-500',
        bgColor: 'bg-red-50 dark:bg-red-900/20',
        borderColor: 'border-red-200 dark:border-red-800',
        textColor: 'text-red-800 dark:text-red-200',
        message: '网络连接已断开',
        description: '请检查您的网络连接'
      }
    }

    const connectionInfo = {
      icon: Wifi,
      color: 'text-green-500',
      bgColor: 'bg-green-50 dark:bg-green-900/20',
      borderColor: 'border-green-200 dark:border-green-800',
      textColor: 'text-green-800 dark:text-green-200',
      message: '网络连接已恢复',
      description: `连接类型: ${connectionType}`
    }

    return connectionInfo
  }

  const info = getConnectionInfo()
  const Icon = info.icon

  return (
    <AnimatePresence>
      {showStatus && (
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50 }}
          transition={{ duration: 0.3 }}
          className="fixed top-4 left-1/2 transform -translate-x-1/2 z-[10000]"
        >
          <div className={`flex items-center space-x-3 px-4 py-3 rounded-lg shadow-lg border ${info.bgColor} ${info.borderColor} backdrop-blur-md`}>
            <Icon className={`w-5 h-5 ${info.color}`} />
            <div className="flex-1">
              <p className={`text-sm font-medium ${info.textColor}`}>
                {info.message}
              </p>
              <p className={`text-xs ${info.textColor} opacity-80`}>
                {info.description}
              </p>
            </div>
            {!isOnline && (
              <button
                onClick={handleRetry}
                className="p-1 rounded-full hover:bg-white/20 transition-colors"
                title="重试连接"
              >
                <RefreshCw className="w-4 h-4 text-gray-600 dark:text-gray-400" />
              </button>
            )}
            <button
              onClick={() => setShowStatus(false)}
              className="p-1 rounded-full hover:bg-white/20 transition-colors"
              title="关闭"
            >
              <AlertCircle className="w-4 h-4 text-gray-600 dark:text-gray-400" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default NetworkStatus